import CardWrapper from '../card-wrapper';
import Step06Image from '../../../../../assets/images/memory/onboarding/step-06.png';
import { Typography } from '../../../../../core/components/molecules/Typography';
import StepButton from '../step-button';
import { Icon } from '../../../../../core/components/atoms/Icon';

const Step06 = ({
  onNextStep,
  onPreviousStep,
}: {
  onNextStep: () => void;
  onPreviousStep: () => void;
}) => {
  return (
    <CardWrapper.Root side='right'>
      <CardWrapper.Primary className='flex flex-col items-center justify-center gap-4 px-5'>
        <div className='flex w-full flex-col items-start justify-center gap-4'>
          <Typography
            title='h1'
            className='!text-h1 font-bold text-mono-color-darker'
          >
            Parabéns
          </Typography>
          <Typography className='flex flex-col gap-4 !text-md !font-normal text-mono-color-darker'>
            Agora você já está pronto para começar a estudar com os
            Flashcards!
          </Typography>
        </div>
        <div className='flex w-full justify-end flex-col md:flex-row'>
          <StepButton
            label='Iniciar Novamente'
            onClick={onPreviousStep}
            type='text'
          />
          <StepButton
            label='Começar a estudar'
            onClick={onNextStep}
            icon={<Icon Icon={'menu_book'} type='material' />}
          />
        </div>
      </CardWrapper.Primary>

      <CardWrapper.Secondary className='h-[438px] w-[554px]'>
        <img
          src={Step06Image}
          alt='Step 06'
          className='h-full w-full rounded-lg md:object-cover object-contain'
        />
      </CardWrapper.Secondary>
    </CardWrapper.Root>
  );
};

export default Step06;
